//imports
import {
    ASSOCIATE_TO_GPS_OPEN_MODAL,
    ASSOCIATE_TO_GPS_CLOSE_MODAL,
    ASSOCIATE_TO_GPS_REQUEST,
    ASSOCIATE_TO_GPS_RESULT,
    CLEAR_REDUX,
} from "Redux/actionTypes";

//initial values
const INIT_STATE = {
    loading: false,
    openModal: false,
    result: null,
};

//change redux object
export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case ASSOCIATE_TO_GPS_OPEN_MODAL:
            return { ...state, openModal: true }

        case ASSOCIATE_TO_GPS_CLOSE_MODAL:
            return { ...state, openModal: false }

        case ASSOCIATE_TO_GPS_REQUEST:
            return { ...state, loading: true }

        case ASSOCIATE_TO_GPS_RESULT:
            return { ...state, loading: false, result: action.payload }

        case CLEAR_REDUX:
            return ["", "ASSOCIATE_TO_GPS"].includes(action.payload.option)
                ? action.payload.parameters
                    ? { ...state, ...action.payload.parameters }
                    : { ...INIT_STATE }
                : { ...state };

        default:
            return state;
    }
};
